import getScenarioStore from '../selectors/getScenarioStore';
import { createDefaultSearchStore } from '../store/store';
import { mutator } from 'satcheljs';
import { removeSuggestionSegmentFromSearchBoxInternal } from '../actions/internalActions';
import { trace } from 'owa-trace';

export default mutator(removeSuggestionSegmentFromSearchBoxInternal, actionMessage => {
    const store = getScenarioStore(actionMessage.scenarioId);

    const suggestionSegments = store.suggestionSegments;
    const segmentKey = actionMessage.segmentKey;

    /**
     * If an entry for the given segmentKey exists, remove it. Otherwise, log
     * an error because that shouldn't happen.
     */
    if (suggestionSegments.has(segmentKey)) {
        // Remove map entry for given key.
        suggestionSegments.delete(segmentKey);

        // Reset selected pill index.
        store.selectedPillIndex = createDefaultSearchStore().selectedPillIndex;
    } else {
        trace.warn(
            "removeSuggestionSegmentFromSearchBox was dispatched with a segmentKey that doesn't exist in searchStore.suggestionSegments map."
        );
    }
});
